// extracted by mini-css-extract-plugin
export default {"input__group":"Input_input__group__ITufj","label":"Input_label__6nNEX","input":"Input_input__QB9GD"};